/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumDashboard.vue?vue&type=template&id=d4540116&scoped=true"
import script from "./ForumDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumDashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumDashboard.vue?vue&type=style&index=0&id=d4540116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4540116",
  null
  
)

export default component.exports